// Boot chrome rendered while auth is still resolving. Deliberately duplicates
// RootLayout's shell geometry — cheaper than threading "auth not ready"
// through its data hooks, and the transition stays seamless.

export default function AuthBootScreen() {
  return (
    <div className="layout-component">
      <aside className="sidebar-component">
        <div className="nav-component">
          <div className="nav-component-wrapper">
            <div className="nav-logo">
              <img src="/favicon.png" alt="Withings" style={{ borderRadius: 6 }} />
            </div>
          </div>
        </div>

        {/* Empty nav slot — keeps the sidebar flex layout consistent so
            the profile skeleton stays anchored to the bottom. */}
        <div className="sidebar-nav" aria-hidden="true" />

        <div className="sidebar-profile-wrap">
          <div
            className="sidebar-profile"
            style={{ pointerEvents: 'none' }}
            aria-label="Loading profile"
            aria-busy="true"
          >
            <div className="skeleton-circle" style={{ width: 36, height: 36 }} />
          </div>
        </div>
      </aside>

      <main className="main-content">
        <div className="loading-center" style={{ minHeight: '60vh' }}>
          <div className="loading-spinner" />
        </div>
      </main>
    </div>
  );
}
